import React from 'react';
import { SummaryCard } from '../../ui/SummaryCard';
import {
  UsersIcon,
  ProjectIcon,
  ApiKeyIcon
} from '../../ui/Icons';
import { ProcessedUser } from '../../../hooks/useProcessedUsers';
import { OrganizationData } from '../types';

interface OrganizationSummaryCardsProps {
  data: OrganizationData;
  processedUsers: ProcessedUser[];
}

export const OrganizationSummaryCards: React.FC<OrganizationSummaryCardsProps> = ({ data, processedUsers }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4">
      <SummaryCard
        title="Active Projects"
        value={data.projects.filter(p => p.status === 'active').length}
        icon={<ProjectIcon />}
        variant="slate"
      />
      <SummaryCard
        title="Active Users"
        value={processedUsers.filter(u => u.status === 'Active').length}
        icon={<UsersIcon />}
        variant="emerald"
      />
      <SummaryCard
        title="Total API Keys"
        value={data.projectDetails.reduce((total, detail) => total + detail.apiKeys.length, 0)}
        icon={<ApiKeyIcon />}
        variant="amber"
      />
    </div>
  );
};
